import { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { retrieveAccordion } from "../../../../../redux/slice/accordion-slice";
import { retrievePageMenu } from "../../../../../redux/slice/page-menu.slice";
import { useAppDispatch, RootState } from "../../../../../redux/store";
import LoadingComp from "../../../../../components/re-usable/loading/loading";

const AwardsComponent = () => {
  const path = "Who-We-Are%2FCelebrate-the-Profession%2FAwards";
  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);
  const { AccordionData } = useSelector((state: RootState) => state.Accordion);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
    dispatch(retrieveAccordion(`%2FWho-We-Are%2FCelebrate-the-Profession%2FAwards%2FAwards-Accordion`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      <div className="row">
        <div className="col-md-12">
          <h3>Meet Past RAPS Award Recipients</h3>
          <Accordion alwaysOpen flush className="convergence ash-accordion" id="awards">
            {AccordionData[0]?.data?.map((item, index) => {
              return (
                <Card>
                  <Card.Header>
                    <Accordion.Item eventKey={index.toString()} key={index}>
                      <Accordion.Header className="btn btn-block heading">
                        <span>{item.name}</span>
                        <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow">
                          &nbsp;
                        </i>
                      </Accordion.Header>
                      <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              );
            })}
          </Accordion>
        </div>
      </div>
      <style>
        {`.awardsSection .photos1 img { padding: 5px; height: 180px; }
            .awardsSection .photos2 img { padding: 5px; height: 180px; }
            .awardsSection .photos3 img { width: 150px; padding: 5px; }
            .awardsSection .photos4 img { padding: 5px; height: 150px; }
            .awardsSection .caption { font-style: italic; font-size: 10pt; color: #5D6280; }
            
            .headshot {
             height: 180px;
             margin: 12px 10px;
             border: 2px solid gray;
            }
            .groupshot { height: 180px; margin: 2px; }
            span.headshot {
              font-size: 145px;
            }
            .logo {
             margin: 10px;
             height: 120px;
            }
            #awards .heading {
                float: left;
            }
            .card-header button { background-color: #B5C5D9 !important; }
            @media only screen and (max-width: 600px) {
              .awardsSection div[class^="photos"] { display: none; }
            }
            #awards .heading{
              float: none !important;
            }
            `}
      </style>
    </>
  );
};

export default AwardsComponent;
